import { render, staticRenderFns } from "./layout-landingpage-footer.vue?vue&type=template&id=7ea83bc0&"
import script from "./layout-landingpage-footer.vue?vue&type=script&lang=js&"
export * from "./layout-landingpage-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports